import { Paper, useTheme } from "@mui/material";
import { Copyright } from "../../Base/helper/baseFunctions";

const Footer = () => {
    const theme = useTheme();
    return (
        <Paper
            sx={{
                zIndex: "9999",
                position: "fixed",
                bottom: 0,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                backgroundColor: `${theme.palette.mode === "dark" ? theme.palette?.dark?.main : theme.palette?.root?.main}`,
            }}
        >
            <Copyright />
        </Paper>
    )
}

export default Footer;